import { baseClient, userApiClient } from '@/core/infrastructure/api/apiClient';
import { translate } from '@/core/utils/translate';
import { initialFilterParams_User } from '@/modules/users/type';

interface IndexSizeModel {
  index: number;
  size: number;
}

export const payloadIndexSize: IndexSizeModel = {
  index: 0,
  size: 500,
};

export const commonQueries = {
  keys: {
    all: ['dd-options'] as const,
    list: () => [...commonQueries.keys.all, 'list'] as const,
    executiveDate: () => [...commonQueries.keys.list(), 'dd-executiveDate'] as const,
    companyOwnedChannels: (data) =>
      [...commonQueries.keys.list(), 'dd-company-owned-channels', { data }] as const,
    menuProfile: () => ['menu-profile'] as const,
    poroductList: () => [...commonQueries.keys.list(), 'dd-product-list'] as const,
  },
  fn: {
    fetchExecutiveDate: async () => {
      try {
        const payload = {
          ...initialFilterParams_User,
          ...payloadIndexSize, // index ve size burada override edilir
        };
        const response = await userApiClient.post('users/search', payload);
        return response.data;
      } catch (error: any) {
        throw new Error(
          translate('errors/api:list_fetch_failed', {
            error: error.response?.data?.message || error.message,
          })
        );
      }
    },
    fetchCompanyOwnedChannels: async (companyIds: string[]) => {
      try {
        const payload = {
          ...payloadIndexSize,
          companyIds,
        };

        const response = await baseClient.post('channels/search/company', payload);
        return response.data;
      } catch (error) {
        throw new Error(translate('errors/api:list_fetch_failed', { error }));
      }
    },

    fetchMenuProfile: async () => {
      try {
        const response = await baseClient.get('account/menu-profile');
        return response.data;
      } catch (error) {
        throw new Error(translate('errors/api:menu_profile_fetch_failed', { error }));
      }
    },
    fetchProductList: async () => {
      try {
        const response = await baseClient.post('products/search', initialFilterParams_User);
        return response.data;
      } catch (error) {
        throw new Error(translate('errors/api:list_fetch_failed', { error }));
      }
    },
  },
  mutations: {
    uploadUserProfileImage: async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await baseClient.post('/images/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        return response.data;
      } catch (error) {
        throw new Error(translate('errors/api:profile_image_upload_failed'));
      }
    },
  },
};
